import React from 'react';
import { connect } from 'react-redux';

import { withRouter } from 'react-router';

import { 
  Button, 
  Card, 
  Col, 
  message, 
  Popconfirm, 
  Row, 
  Table,
  Tag,
  Input
} from 'antd';

import moment from 'moment';

import debounce from 'debounce';

import { setQuotationCart } from './actions';
import { 
  _deleteQuotation,
  _getQuotation, 
  _getQuotations, 
  _postCreateEmptyQuotation, 
  _postManualDeliveryCharge, 
  _getCartByReference, 
  _getCart
} from '../../services';

import AddQuotationModal from './add-quotation-modal';

import './index.css';

class Quotation extends React.Component {
  
  render() {
    if( this.state.hasError ){
      return (
        <p style={{whiteSpace: "pre-line"}}>
          {this.state.stack} <br/>
          {this.state.errorInfo.componentStack}
        </p>
      )
    }


    const certainCondition = true;
    
    return (
      <div style={{padding: '10px'}}>
        


        {
          this.state.modalIsVisible && (
            <AddQuotationModal 
              modalIsVisible={this.state.modalIsVisible} 
              hideModal={this.hideModal} />
          )
        }
        
        <Card 
          title={(
            <Row type="flex" gutter={8}>
              <Col>
                <Button 
                  onClick={ () => this.changeMode("draft-quotations")}
                  type={ this.state.mode === "draft-quotations"? "primary": ""}>Drafts</Button>
              </Col>
  
              <Col>
                <Button
                  onClick={ () => this.changeMode("my-quotations")}
                  type={ this.state.mode === "my-quotations"? "primary": ""}>Quoted by me</Button>
              </Col>
  
              <Col>
                <Button
                  onClick={ () => this.changeMode("team-quotations")}
                  type={ this.state.mode === "team-quotations"? "primary": ""}>Quoted by Team</Button>
              </Col>

              <Col >
                <Input.Search
                  className={`${this.state.searchTerm? "active": ""}`}
                  style={{ 
                    width: 300
                  }}
                  placeholder="Search company name or email"
                  onChange={(e)=>this.handleOnChangeSearchTerm(e.target.value)}
                />
              </Col>
              {/* <Col >
                <Input.Search
                  style={{ 
                    width: 150
                  }}
                  placeholder="Reference Number"
                  onSearch={(refNumber)=>this.handleSearchReferenceNumber(refNumber)}
                />
              </Col> */}

            </Row>
          )}
          extra={
  
            <Row type="flex" gutter={8}>
            
              <Col>
                {/* <Button onClick={this.addQuotationAndShowModal} icon="plus-square"> */}
                <Button onClick={() => null} disabled icon="plus-square">
                  New Quotation - Create on ERP!
                </Button>
              </Col>
              
            </Row>  
        }>

          { this.renderQuotationTable() }
        
        
        </Card>
      
      
      </div>
    )
  }

  renderQuotationTable = () => {

    const adminHashTable = this.props.admins.userIdEmailMap;
   
    const { quotations } = this.state;

    const columnData = [
      {
        width: 50,
        title: "#",
        key: "index",
        render: (text, record, index) => {
          return this.state.count - (index + ((this.state.page - 1) * this.state.pageSize))
        }
      },
      {
        title: "Ref",
        key: "refNumber",
        dataIndex: "refNumber"
      },
      
    ]

    switch( this.state.mode ){

      case "draft-quotations":

        columnData.push(
          {
            title: "Date",
            key: "date",
            dataIndex: "dateCreated",
            render: ( date ) => {
              return moment(date).format('DD/MM/YY - hh:mmA')
            }
          }
        )

        columnData.push({
          title: "Email",
          key: "email",
          render: ( data ) => {
            if ( data.user ){
              return data.user.local.email
            }
            
            return (
              <Tag color="red">NO USER</Tag>  
            );
          }
        });

        columnData.push({
          title: "Actions",
          key: "action",
          render: ( record ) => {
            return (
              <Button.Group>
                <Button 
                  size="small" 
                  type="primary"
                  onClick={ () => this.getQuotationAndOpenModal( record._id ) }>
                  Edit
                </Button>

                <Popconfirm 
                  placement="top" 
                  title={"Are you sure delete this quotation?"} 
                  onConfirm={ () => this.deleteDraftQuotation( record._id ) } 
                  okText="Yes" 
                  cancelText="No">

                  <Button size="small" type="danger">
                    Delete
                  </Button>
                </Popconfirm>
              </Button.Group>
            )
          }
        });
        break;

      case "my-quotations":

        columnData.push(
          {
            title: "Date",
            key: "date",
            dataIndex: "lastContact.quoteAndForgetDate",
            render: ( date ) => {
              return moment(date).format('DD/MM/YY - hh:mmA')
            }
          }
        )

        columnData.push({
          title: "Email",
          key: "email",
          render: ( data ) => {
            if ( data.user ){
              return data.user.local.email
            }
            
            return (
              <Tag color="red">NO USER</Tag>  
            );
          }
        });

        columnData.push({
          title: "Company",
          key: "company",
          dataIndex: 'activeShipping.companyName'
        });

        columnData.push({
          title: "Actions",
          key: "action",
          render: ( record ) => {
            return (
              <Button.Group>
                <Button 
                  size="small" 
                  type="primary"
                  onClick={ () => this.getQuotationAndOpenModal( record._id ) }>
                  View
                </Button>
              </Button.Group>
            )
          }
        });

        break;

      case "team-quotations":
        columnData.push(
          {
            title: "Date",
            key: "date",
            dataIndex: "lastContact.quoteAndForgetDate",
            render: ( date ) => {
              return moment(date).format('DD/MM/YY - hh:mmA')
            }
          }
        )

        columnData.push({
          title: "Email",
          key: "email",
          render: ( data ) => {
            if ( data.user ){
              return data.user.local.email
            }
            
            return (
              <Tag color="red">NO USER</Tag>  
            );
          }
        });
        
        columnData.push({
          title: "Company",
          key: "company",
          dataIndex: 'activeShipping.companyName'
        });

        columnData.push({
          title: "Manager",
          key: "createdBy",
          dataIndex: 'createdBy',
          render: ( text ) => {
            return adminHashTable[text];
          }
        })
        
        columnData.push({
          title: "Actions",
          key: "action",
          render: ( record ) => {
            return (
              <Button.Group>
                <Button 
                  size="small" 
                  type="primary"
                  onClick={ () => this.getQuotationAndOpenModal( record._id ) }>
                  View
                </Button>
              </Button.Group>
            )
          }
        });

        break;

      default:
      break;
    }

    return (
      <Table 
        loading={ this.state.loading }
        size="middle"
        rowKey="_id"
        columns={columnData} 
        dataSource={quotations}
        pagination={{
          total: this.state.count,
          pageSize: this.state.pageSize,
          current: this.state.page,
          onChange: ( page ) => {
            this.getQuotations( page )
          }
        }}
      />
    )

  }

  constructor(props) {
    super(props);

    this.state = {
      modalIsVisible: false,
      quotation: {},
      mode: "draft-quotations",
      page: 1,
      pageSize: 10,
      quotations:[],
      count: 0,
      loading: false,
      dataSource:[],
      searchTerm:""
    }

    this.handleOnChangeSearchTermAsync = debounce( this.handleOnChangeSearchTermAsync, 300 );

  }
  
  componentDidMount(){
    this.getQuotations();

    // @LEARNING
    // _postManualDeliveryCharge(9, "for-bryce-demo")
    //   .then( res => {
    //     console.log( 'request made');
    //   })
    //   .catch( e => {
    //     console.log("there was an error");
    //   })
    
    if( this.props.quotationId ){
      this.getQuotationAndOpenModal( this.props.quotationId );
    }
  }
  
  componentDidCatch(error, errorInfo) {
    // Display fallback UI
    this.setState({ 
      hasError: true, 
      errorInfo, 
      stack: error.stack
    });
    
  }
  

  addQuotationAndShowModal = () => {
  
    message.loading('Adding quotation...');

    _postCreateEmptyQuotation()
      .then(
        res => {  

          message.destroy();

          this.getQuotations();
          
          this.props.setQuotationCart( res.data.cart );

          this.setState({
          //  quotation: res.data.cart,
            modalIsVisible: true,
          });

        }
      )
  }

  changeMode = ( mode ) => {
    this.setState({ mode, quotations:[] }, this.getQuotations )
  }

  deleteDraftQuotation = ( quotationId ) => {
    _deleteQuotation( quotationId ) 
      .then( res => {
        this.getQuotations();
      })
  }

  getQuotations = ( page = 1 ) => {

    const { searchTerm } = this.state;

    let options = {
      page
    };
    
    // if user id still getting, try again in 500 ms
    if( !this.props.user.data._id ){
      return setTimeout( () => this.getQuotations( page ), 500 );
    }

    switch( this.state.mode ){
      case "draft-quotations":
        options.draft = true;
        options.userId = this.props.user.data._id;
        break;

      case "my-quotations":
        options.userId = this.props.user.data._id;
        break;

      case "team-quotations":
        break;

      default:
        break;
    }


    if( searchTerm && searchTerm.length > 0 ){
      options.searchTerm = searchTerm;
    }

    this.setState({ loading: true }, () => {
      _getQuotations(options)
        .then(
          res => {
            this.setState({
              loading: false,
              quotations: res.data.orders,
              count: res.data.count,
              page
            })
          }
        )
    })

  }
  
  getQuotationAndOpenModal = ( cartId ) => {
    // _getQuotation
    
    message.loading('Loading quotation...');

    _getQuotation( cartId )
      .then(
        ( res ) => {  

          message.destroy();

          this.props.setQuotationCart( res.data.order );

          this.setState({
            modalIsVisible: true,
          });

        }
      )
  }

  handleOnChangeSearchTerm = (searchTerm) =>{

    this.handleOnChangeSearchTermAsync( searchTerm );

  }

  handleSearchReferenceNumber = ( refNumber ) => {

    _getCartByReference(refNumber)
    .then( res => {

        this.getQuotationAndOpenModal(res.data.cartId)

    })
  }

  handleOnChangeSearchTermAsync = ( searchTerm ) => {

    this.setState({ 
      searchTerm, 
      mode: "team-quotations" 
    }, this.getQuotations );

  }

  hideModal = () => {
    
    this.props.history.push('/quotation');
    
    if( this.state.mode !== "team-quotations"){
      this.getQuotations( this.state.page );
    }

    this.setState({
      modalIsVisible: false,
    })
  }

}

export default connect(
 
  state => ({
    user: state.user,
    admins: state.admins
  }),
  
  dispatch => ({
    setQuotationCart: ( cart ) => dispatch( setQuotationCart( cart ) )
  })

)( 
  withRouter(Quotation)
);


// WEBPACK FOOTER //
// ./src/components/quotation/index.js